import {
  IMAGE_NODE_TYPE,
  LessonContentImageSource,
  LessonContentVideo,
  VIDEO_NODE_TYPE,
} from '../../data/models/LessonContent/LessonContentBase';
import {
  LessonContentItem,
  LessonContentList,
} from '../../data/models/LessonContent/LessonContentList';
import {PostMediaItem} from '../../data/models/Posts/Post';

// A post's content is a single chain, so the running order is found by walking
// it from the root rather than by reading the item map.
export const readPostContent = (content: LessonContentList) => {
  const items: PostMediaItem[] = [];
  const nodes = content.contentList?.items ?? {};
  let currentId: string | undefined = content.contentList?.rootId;

  while (currentId && nodes[currentId]) {
    const node: LessonContentItem = nodes[currentId];
    if (node.data.ivNodeType === VIDEO_NODE_TYPE) {
      const video = node.data as LessonContentVideo;
      items.push({
        id: video.internalId,
        isVideo: true,
        title: video.title,
        url: video.contentUrl,
        poster: video.placeholderUrl,
      });
    } else if (node.data.ivNodeType === IMAGE_NODE_TYPE) {
      const image = node.data as LessonContentImageSource;
      items.push({
        id: image.internalId,
        isVideo: false,
        title: image.title,
        url: image.contentUrl,
      });
    }
    currentId = node.childIds ? node.childIds[0] : undefined;
  }

  return items;
};

export const renamePostNode = (
  content: LessonContentList,
  internalId: string,
  title: string,
) => {
  const node = content.contentList?.items[internalId]?.data;
  if (!node) return undefined;
  return {...node, title};
};
